import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {ChatCanvasVersionQuery} from './__generated/ChatCanvasVersionQuery';

export const CHAT_CANVAS_VERSION_QUERY: DocumentNode = gql`
  query ChatCanvasVersionQuery($chatSessionId: StrictString!, $canvasVersionId: StrictString!)
  @skipAudit
  @engComponent(name: CANVAS_CORE) {
    chatCanvasVersion(chatSessionId: $chatSessionId, canvasVersionId: $canvasVersionId) {
      ... on ChatCanvasVersionNode {
        id
        versionIndex
        definitionId
        definitionName
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export type ChatCanvasVersionGraphQL = ExtractByTypename<
  ChatCanvasVersionQuery['chatCanvasVersion'],
  'ChatCanvasVersionNode'
>;
